var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('page-with-button',{attrs:{"img":require('@/assets/logo.png'),"title":"Waiting for approval","titleDescription":"Your account needs approval from our team.","textDescription":"","icon":"check"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }